import { render, staticRenderFns } from "./NewsFeedEmpty.vue?vue&type=template&id=9fb79d56&"
import script from "./NewsFeedEmpty.vue?vue&type=script&lang=js&"
export * from "./NewsFeedEmpty.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedEmpty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports